// Register Editables
require('./editable/price_extended');
require('./editable/stock');
require('./editable/type');
require('./editable/dimensions');
require('./editable/usage');
require('./editable/order-notes');
require('./editable/variation');
require('./editable/subscription_period');
jQuery(document).ready(($) => {
    $('table.wp-list-table td').on('ajax_column_value_ready', function () {
        // Re-init WC tooltip after column contents has been retrieved by ajax
        $(document.body).trigger('init_tooltips');
    });
    // Prevent row clicking in Order screen when inline edit is active
    $('.post-type-shop_order #the-list td').on('click', () => {
        if ($(this).hasClass('cacie-editable-container')) {
            $(this).parents('tr').data('edit-click', 1);
        }
    });
    $('.post-type-shop_order #the-list tr').on('click', (e) => {
        let $row = $(this);
        if ($row.data('edit-click')) {
            e.stopPropagation();
        }
        $row.data('edit-click', 0);
    });
    document.querySelectorAll('.post-type-product_variation .product_search').forEach(select => {
        jQuery(select).ac_select2({
            theme: 'acs2',
            allowClear: true,
            width: '200px'
        });
    });
    $('.post-type-shop_order .wp-list-table').each(function () {
        let $table = $(this);
        if ($(this).find('#order_number').length === 0) {
            $table.find('tr').each(function () {
                let $check_column = $(this).find('th.check-column'), id = $check_column.find('input[type=checkbox]').val(), url = `${acp_wc_table.edit_post_link}&post=${id}`;
                $(this).find('th.check-column').append(`<a class="order-view" style="display: none;" href="${url}">a</a>`);
            });
        }
    });
    $('.view-variations').on('click', (e) => {
        e.stopPropagation();
    });
});
